export enum DetectedAccidentStatus {
  Verified = 'Verified',
  FalsePositive = 'False Positive',
  NotVerified = 'Not Verified'
}

export const DetectedAccidentStatusLabelKeys: Record<DetectedAccidentStatus, string> = {
  [DetectedAccidentStatus.Verified]: 'accidents.detectedAccident.statuses.verified',
  [DetectedAccidentStatus.FalsePositive]: 'accidents.detectedAccident.statuses.falsePositive',
  [DetectedAccidentStatus.NotVerified]: 'accidents.detectedAccident.statuses.notVerified'
}